// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"watisweef-module--wrapper--1qMOH","tekst":"watisweef-module--tekst--2eIbo","fotos":"watisweef-module--fotos--1NVB7"};